<template>
  <div class="container-fluid">
    <div class="row page-titles">
      <div class="col-md-6">
        <breadcrumbs :current="id"></breadcrumbs>
      </div>
      <!--<div class="col-md-6" v-if="isCompleted && hasTransactions && howOldInHours < 72">-->
        <!--<div class="float-right"><a class="btn btn-warning" target="_blank" :href="creditLink">Request Credit</a></div>-->
      <!--</div>-->
    </div>
    <div v-if="showSpinner" class="spinner-wrap">
      <spinner/>
    </div>
    <div class="row" v-else-if="!isOverdue">
      <!-- column -->
      <div class="col-lg-6">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Lead {{ isCompleted ? 'Completed' : 'Partial' }}</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table no-border">
                <tbody>
                  <tr>
                    <td class="strong">ID</td>
                    <td>{{ id }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Ticket</td>
                    <td>{{ ticketId }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Created</td>
                    <td>{{ lead.created | moment("MMM Do YYYY, h:mm:ss a") }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Customer</td>
                    <td>
                      <router-link class="" :to="{ name: 'EditCompany', params: { id: company.id } }">
                        {{company.companyName}}
                      </router-link>
                    </td>
                  </tr>
                  <tr>
                    <td class="strong">Campaign</td>
                    <td>
                      <router-link class="" :to="{ name: 'CampaignDetails', params: { id: campaign.id } }">
                        {{campaign.campaignName}}
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Widget Context</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table no-border">
                <tbody>
                  <tr>
                    <td class="strong">Title</td>
                    <td>{{ context.title }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Subtitle</td>
                    <td>{{ context.subtitle }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Prompt</td>
                    <td>{{ context.prompt }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Type</td>
                    <td>{{ leadData.type }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Original Type</td>
                    <td>{{ leadData.type_original }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- column -->
      <div class="col-12" v-if="navigator.href">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Origin URL</h4>
          </div>
          <div class="card-body">
            <h5><a :href="navigator.href" target="_blank">{{ navigator.href }}</a></h5>
          </div>
        </div>
      </div>
      <!-- column -->
      <div class="col-12">
        <div class="card card-outline-info">
          <div class="card-header">
            <h4 class="mb-0 text-white">Visitor Input</h4>
          </div>
          <div class="card-body">
            <h5>{{ lead.input }}</h5>
            </div>
        </div>
      </div>
      <!-- column -->
      <div class="col-12">
        <div class="card card-outline-info">
          <div class="card-header">
            <h4 class="mb-0 text-white">Visitor Answers</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Type</th>
                    <th>Question</th>
                    <th>Answer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="question in lead.questions" :key="question.id">
                    <td>{{ question.fieldName }}</td>
                    <td>{{ question.type }}</td>
                    <td>{{ question.question }}</td>
                    <td>
                      <span v-if="question.type === 'Date'">
                        {{ question.answer | date }}
                      </span>
                      <span v-else>
                        {{ question.answer.join(', ') }}
                        </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- column -->
      <div class="col-12" v-if="lead.notes">
        <div class="card card-outline-info">
          <div class="card-header">
            <h4 class="mb-0 text-white">Agent Notes</h4>
          </div>
          <div class="card-body">
            <h5>{{ lead.notes }}</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-6" v-if="isChat">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Chat with Agent # {{lead.agentId}}</h4>
          </div>
          <div class="card-body fixed-height chat-rbox p-0">
            <ul class="chat-list">
              <li v-for="item of chat" :key="item.key" :class="{'reverse': item.byRepresentative}">
                <div class="chat-content" v-if="item.byRepresentative">
                  <h5>
                    <span class="timestamp">({{ item.timestamp | moment("h:mm a") }})  </span>
                    Agent
                  </h5>
                  <div class="box bg-light-inverse">
                    {{item.message}}
                    <div v-if="item.seenAt" class="timestamp"><i class="mdi mdi-check"></i> Seen at {{ item.seenAt | moment("h:mm a") }}</div>
                  </div>
                </div>
                <div class="chat-content" v-else>
                  <h5>
                    Lead
                    <span class="timestamp">  ({{ item.timestamp | moment("h:mm a") }})</span>
                  </h5>
                  <div class="box bg-light-info">{{item.message}}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6" v-if="isCall">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Call Geo</h4>
          </div>
          <div class="card-body fixed-height">
            <div class="table-responsive">
              <table class="table no-border">
                <tbody>
                <tr>
                  <td class="strong">City</td>
                  <td>{{ call.city }}</td>
                </tr>
                <tr>
                  <td class="strong">State/Province</td>
                  <td>{{ call.state }}</td>
                </tr>
                <tr>
                  <td class="strong">Country</td>
                  <td>{{ call.country }}</td>
                </tr>
                <tr>
                  <td class="strong">Zip/Postal</td>
                  <td>{{ call.zip }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6" v-if="isChat">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Stats</h4>
          </div>
          <div class="card-body fixed-height">
            <div class="table-responsive">
              <table class="table no-border">
                <tbody>
                <tr>
                  <td class="strong">Total questions</td>
                  <td>{{ stats.numberOfQuestions }}</td>
                </tr>
                <tr>
                  <td class="strong">Mandatory questions</td>
                  <td>{{ stats.numberOfMandatoryQuestions }}</td>
                </tr>
                <tr>
                  <td class="strong">Answered questions</td>
                  <td>{{ stats.numberOfQuestionsAnswered }}</td>
                </tr>
                <tr v-if="!isCall">
                  <td class="strong">Questions seen by visitor</td>
                  <td>{{ stats.numberOfQuestionsSeenByVisitor }}</td>
                </tr>
                <tr v-if="!isCall">
                  <td class="strong">Messages in chat</td>
                  <td>{{ stats.numberOfMessages }}</td>
                </tr>
                <tr>
                  <td class="strong">Agent Responded</td>
                  <td>{{ stats.agentResponseTime | duration('asSeconds') }} sec</td>
                </tr>
                <tr v-if="!isCall">
                  <td class="strong">Seen by visitor for</td>
                  <td>{{ stats.seenByVisitorTime | duration('asSeconds') }} sec</td>
                </tr>
                <tr v-if="!isCall">
                  <td class="strong">Closed by visitor after</td>
                  <td>{{ stats.closedByVisitorTime | duration('asSeconds') }} sec</td>
                </tr>
                <tr v-if="!isCall">
                  <td class="strong">Chat duration</td>
                  <td>{{ stats.chatTime | duration('asSeconds') }} sec</td>
                </tr>
                <tr v-if="isCall && call.recording">
                  <td class="strong">Call Duration</td>
                  <td>{{ call.recording.RecordingDuration }} sec</td>
                </tr>
                <tr v-if="isCall && call.recording">
                  <td class="strong">Call Recording</td>
                  <td><a :href="call.recording.RecordingUrl" target="_blank">Play</a></td>
                </tr>
                <tr v-if="isCall && call.vm">
                  <td class="strong">Voicemail Duration</td>
                  <td>{{ call.vm.RecordingDuration }} sec</td>
                </tr>
                <tr v-if="isCall && call.vm">
                  <td class="strong">Voicemail Recording</td>
                  <td><a :href="call.vm.RecordingUrl" target="_blank">Play</a></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6" v-if="!isCall">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Visitor Info</h4>
          </div>
          <div class="card-body fixed-height">
            <div class="table-responsive">
              <table class="table no-border">
                <tbody>
                  <tr>
                    <td class="strong">IP Address</td>
                    <td>{{ visitor.ip }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Time Zone</td>
                    <td>{{ visitor.timezone }} ({{ visitor.timezone_id }})</td>
                  </tr>
                  <tr>
                    <td class="strong">Currency</td>
                    <td>{{ visitor.currency }}</td>
                  </tr>
                  <tr>
                    <td class="strong">City</td>
                    <td>{{ visitor.city }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Region</td>
                    <td>{{ visitor.region_name }} ({{ visitor.region_code }})</td>
                  </tr>
                  <tr>
                    <td class="strong">Country</td>
                    <td>{{ visitor.country_name }} ({{ visitor.country_code }})</td>
                  </tr>
                  <tr>
                    <td class="strong">Zip/Postal</td>
                    <td>{{ visitor.zip }}</td>
                  </tr>
                  <tr>
                    <td class="strong">Geo (lat/long)</td>
                    <td>{{ visitor.latitude }} , {{ visitor.longitude }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6" v-if="!isCall">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Device Info</h4>
          </div>
          <div class="card-body fixed-height">
            <table class="table no-border">
              <tbody>
              <tr>
                <td class="strong">Type</td>
                <td>{{navigator.deviceType}}</td>
              </tr>
              <tr>
                <td class="strong">Screen</td>
                <td>{{navigator.screenWidth}} x {{navigator.screenHeight}}</td>
              </tr>
              <tr>
                <td class="strong">Viewport</td>
                <td>{{navigator.viewportWidth}} x {{navigator.viewportHeight}}</td>
              </tr>
              <tr>
                <td class="strong">Page</td>
                <td>{{navigator.docWidth}} x {{navigator.docHeight}}</td>
              </tr>
              <tr>
                <td class="strong">Language</td>
                <td>{{navigator.language}}</td>
              </tr>
              <tr>
                <td class="strong">User Agent</td>
                <td>{{navigator.userAgent}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-lg-12" v-if="Number.isFinite(visitor.latitude) && Number.isFinite(visitor.longitude)">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Map</h4>
          </div>
          <div class="card-body fixed-height p-0">
            <map-component
              :lat="visitor.latitude"
              :lng="visitor.longitude"
              :zoom="10"
              marker
            />
          </div>
        </div>
      </div>
      <!-- column -->
      <div class="col-12" v-if="hasTransactions">
        <div class="card card-outline-inverse-light">
          <div class="card-header">
            <h4 class="mb-0">Transactions</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Notes</th>
                  <th v-if="isUserAdmin" class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="trx in transactions" :key="trx.id">
                  <td>{{ trx.created | moment("MMM Do YYYY") }}</td>
                  <td>{{ trx.currency }} {{ trx.amount | currency }}</td>
                  <td>{{ trx.notes }}</td>
                  <td v-if="isUserAdmin && trx.amount < 0">
                    <router-link
                      tag="button"
                      class="btn btn-info float-right"
                      :to="{ name: 'LeadRefund', params: {trx: trx} }"
                    >
                      Refund
                    </router-link>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="card card-outline-inverse-light">
			<div class="card-body without-details">
				<h2>Your account is overdue, please add a payment method.</h2>
				<router-link 
					class="btn btn-info"
					:to="{ name: 'EditCompany', params: { id: getCompany.id }, query: { tab: 'billing' } }"
				>
					Add Payment Method
				</router-link>
			</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import MapComponent from '@/components/Map';
import Spinner from '@/components/Spinner';
import LEAD_QUERY from '../../graphql/Lead/Lead.gql';
import TRANSACTIONS_QUERY from '../../graphql/Transactions/TransactionsByLeadId.gql';

export default {
  name: 'LeadsDetails',
  components: {
    MapComponent,
    Spinner,
  },
  data() {
    return {
      id: this.$route.params.id,
      showSpinner: 0,
      isOverdue: false,
      lead: {},
      transactions: [],
    };
  },
  computed: {
    ...mapGetters(['getCompany', 'isUserAdmin', 'getAuthUser', 'isWhiteLabel']),
    isCompleted() {
      return this.lead.completed;
    },
    ticketId() {
      return this.lead.ticketId;
    },
    company() {
      if (this.lead && this.lead.company) {
        return this.lead.company;
      }
      return {};
    },
    campaign() {
      if (this.lead && this.lead.campaign) {
        return this.lead.campaign;
      }
      return {};
    },
    leadData() {
      if (this.lead && this.lead.data) {
        return this.lead.data;
      }
      return {};
    },
    context() {
      if (this.leadData && this.leadData.context) {
        return this.leadData.context;
      }
      return {};
    },
    visitor() {
      if (this.leadData && this.leadData.visitor) {
        return this.leadData.visitor;
      }
      return {};
    },
    stats() {
      if (this.leadData && this.leadData.stats) {
        return this.leadData.stats;
      }
      return {};
    },
    chat() {
      if (this.leadData && this.leadData.chat) {
        return this.leadData.chat;
      }
      return {};
    },
    navigator() {
      if (this.leadData && this.leadData.navigator) {
        return this.leadData.navigator;
      }
      return {};
    },
    isCall() {
      return this.call.from
    },
    isChat() {
      return this.leadData && this.leadData.type === 'chat';
    },
    call() {
      return (this.leadData && this.leadData.call) ? this.leadData.call : {};
    },
    type() {
      return (this.leadData) ? this.leadData.type : null;
    },
    creditLink() {
      return `https://docs.google.com/forms/d/e/1FAIpQLSe00rC51gw7GaLTk5Ne3HmbUXacT5WdMa71o3X7s7jQ0bkJVw/viewform?usp=pp_url&entry.2039617643=${this.getAuthUser.email}&entry.105432001=${this.id}&entry.2023113411=${this.campaign.campaignName}`;
    },
    hasTransactions() {
      return !!(this.transactions && this.transactions.length > 0);
    },
    howOldInHours() {
      return moment().diff(moment(this.lead.created), 'hours');
    }
  },
  methods: {
    timestamp(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
  apollo: {
    lead: {
      query: LEAD_QUERY,
      loadingKey: 'showSpinner',
      error({ graphQLErrors: errors }) {
        this.isOverdue = Boolean(errors && errors.find(a => a.name === 'ACCESS_DENIED'));
      },
      variables() {
        return {
          id: parseInt(this.id),
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.lead = data.lead;
        }
      },
    },
    transactionsByLeadId: {
      query: TRANSACTIONS_QUERY,
      loadingKey: 'showSpinner',
      error({ graphQLErrors: errors }) {
        this.isOverdue = Boolean(errors && errors.find(a => a.name === 'ACCESS_DENIED'));
      },
      variables() {
        return {
          id: parseInt(this.id),
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.transactions = data.transactionsByLeadId;
        }
      },
    }
  },
};
</script>

<style lang="scss" scoped>
td.strong {
  font-weight: 500;
}
.without-details {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 600px;
}
.fixed-height {
  height: 500px;
  overflow-y: auto;
}
.height-300 {
  height: 300px;
  overflow-y: auto;
}
.chat-rbox {
  flex: 1;
  overflow: auto;

  .chat-list {
    width: 100%;

    li {
      margin-top: 10px;
    }

    & > li {
      .timestamp {
        display: inline-block;
        font-size: 13px;
        color: #c2c9cf;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Leads/LeadDetails.vue